import { Document } from '@contentful/rich-text-types'
import { RichText } from '../../molecules/RichText'

export interface TextComponentProps {
  title: Document
  description: Document
}

export const TextComponent = (props: TextComponentProps) => {
  return (
    <div className="text-align--center">
      <RichText content={props.title} />
      <RichText content={props.description} />
    </div>
  )
}

export default TextComponent
